import {
  Checkbox,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from 'ui'
import { useSigningForm } from '../Provider'
import { SigningFormFieldProps } from './Switcher'

export const CheckboxField = ({
  path,
  field,
  index,
  onPersist,
}: SigningFormFieldProps) => {
  const form = useSigningForm()

  return (
    <FormField
      control={form.control}
      name={path}
      render={({ field: formField }) => (
        <FormItem className='w-full h-full'>
          <FormControl className='w-full h-full'>
            <Checkbox
              indicatorClassName='h-full'
              className='w-full h-full rounded-none border-none focus-visible:ring-0'
              checked={formField.value}
              onCheckedChange={(checked) => {
                formField.onChange(checked)

                onPersist(checked).catch(() => formField.onChange(!checked))
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}
